import { Card, SxProps, Theme } from "@mui/material";
import { Box, styled } from "@mui/system";
import React, { ReactNode } from "react";

// Define the prop types for CardTitle
interface CardTitleProps {
  subtitle?: string;
}

// Define the prop types for SimpleCard
interface SimpleCardProps {
  title?: string;
  subtitle?: string;
  icon?: ReactNode;
  children?: ReactNode;
  sx?: any; 
}

// Styled component for CardRoot
const CardRoot = styled(Card)(() => ({
  height: "100%",
  padding: "0",
  overflow: "auto",
  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  borderRadius: "8px",
  border: "1px solid #e9ecef",
  backgroundColor: "#ffffff",
}));

// Styled component for CardTitle
const CardTitle = styled("div")<CardTitleProps>(({ subtitle }) => ({
  fontSize: "1rem",
  fontWeight: "700",
  color: "#1a2a3a",
  backgroundColor: "#fff",
  position: "relative",
  borderRadius: "0",
  padding: subtitle ? "16px 20px 0" : "16px 20px",
}));

// SimpleCard component
const SimpleCard: React.FC<SimpleCardProps> = ({
  children,
  title,
  subtitle,
  icon,
  sx,
}) => {
  return (
    <CardRoot elevation={6} sx={{ pt: 2, ...sx }}>
      {/* <CardTitle subtitle={subtitle}>{title}</CardTitle> */}
      {subtitle && <Box sx={{ mb: 2}}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
};

export default SimpleCard;
